<div
  class="debug "
  [ngClass]="{'d-none': !this.visible }"
  >
  <ng-content></ng-content>

  @if (this.attService.state.getValue()  !== 'disconnected') {
    <i
      class="ri-customer-service-2-fill ri-2x text-primary"
      [ngClass]="{'text-muted': this.attService.state.getValue()  !== 'listening'}"
    ></i>
    <i
      class="ri-send-plane-fill     ri-2x     text-primary"
      [ngClass]="{'text-muted': this.attService.state.getValue()  !== 'sending'}"
    ></i>
    <i
      class="ri-brain-fill ri-2x text-primary"
      [ngClass]="{'text-muted': this.attService.state.getValue()  !== 'thinking'}"
    ></i>
    <i
      class="ri-speak-ai-fill ri-2x text-primary"
      [ngClass]="{'text-muted': !this.attService.speakingState.getValue()}"
    ></i>
    <br>
      <b>{{this.attService.state}}</b>
      <!-- public state: 'unknown' | 'connecting' | 'listening' | 'thinking' | 'sending' | 'speaking' | 'disconnected' =
      'unknown'; -->
    }

    <b>this.state:</b> {{this.attService.state}} <br>
    <b>this.autoMute:</b> <input
    type="checkbox"
    class="form-check-input"
    [(ngModel)]="this.attService.autoMute"
    /> <br>
    <b>this.chunks:</b> {{this.attService.chunks.length}} <br>
    <b>this.rootMeanSquare</b> {{this.attService.rootMeanSquare | number:'1.3-3' }} <br>
    <b>this.silenceThreshold</b> {{this.attService.silenceThreshold}} <br>
    <b>this.silenceDelay</b> {{this.attService.silenceDelay}}<br>
    <b>this.silenceProgress</b> {{this.attService.silenceProgress | number:'1.0'}}<br>
    <b>this.waitForSpeechInputEnd</b> {{this.attService.waitForSpeechInputEnd }}<br>
    <b>this.speechRecognitionThreshold</b> {{this.attService.speechRecognitionThreshold }}<br>
    <b>this.animationFrameId</b> {{this.attService.animationFrameId }}<br>
    <b>
      @if (this.attService.waitForSpeechInputEnd ) {
        Bereit zum senden
      }
      @if (!this.attService.waitForSpeechInputEnd ) {
        Noch keine Erkennung
      }

      <br />
    </b>
    <div class="progress">


      <div
        class="progress-bar text-end"
        style="transition: none !important;"
        role="progressbar"
        [style.width.%]="this.attService.silenceProgress"
        aria-valuemin="0"
        >
        {{(this.attService.silenceProgress ) | number:'1.0'}}%
      </div>

    </div>
    <span>Recoginition: {{this.attService.rootMeanSquare}}</span>
    <div class="progress align-content-center">
      <div
        class="progress-bar text-end"
        style="transition: none !important;"
        role="progressbar"
        [style.width.%]=" (this.attService.rootMeanSquare) * 1000 "
        aria-valuemin="0"
        >
        {{(this.attService.rootMeanSquare ) | number:'1.0'}}%
      </div>

    </div>
    <div class="progress align-content-center">
      <div
        class="progress-bar text-end"
        style="transition: none !important;"
        role="progressbar"
        [style.width.%]="(this.attService.speechRecognitionThreshold) * 1000 "
        aria-valuemin="0"
        >
        {{(this.attService.speechRecognitionThreshold * 1000 ) | number:'1.0'}}%
      </div>

    </div>
  </div>